import { css } from '@emotion/css'

const TAG_HEIGHT = '28px'

const styles = {
  tag: css({
    height: TAG_HEIGHT,
  }),
}

export default styles
